import axios from 'axios';
import config from "../config/config";

const apiservice = {
    postCall: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
               

                if (response.data.results.errorCode == "9999") {
                  
                    returnData = response.data.results;


                   

                } 
                else if (response.data.results.errorCode == "8888") {
                    returnData = response.data.results;
                }else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getCall: async function (apiURL) {
        try {

            let returnData = {};

            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL,
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }

            });

           
                if(returnData==undefined)
                 returnData="-1";

            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getDepartment: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData,

            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }

    },

    getCounter: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL,

            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getProduct: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData,
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getItem: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getSubproduct: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData,
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getUOM: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getRatemaster: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getTagType: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getHallMarkRate: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getWasteTable: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getPurchasedetail: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getPurity: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    updateDealersmith: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    updateDepartment: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData,

            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }

    },
    insertDealersmith: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    insertDepartment: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    insertUpdateCounter: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    insertUpdateProduct: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    insertUpdateUOM: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    insertUpdatePurity: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    getProductHeadSP: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },
    
    insertUpdateSubProduct: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    uploadImg: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                let imgpathName = response.data.imagePath;
                console.log(imgpathName.length, "res");

                if (Number(imgpathName.length) != 0) {
                    returnData = response.data;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    insertUpdateTagType: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    insertUpdateHallmark: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    getmetaltype: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    insertRateMaster: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    getproductlist: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    getsubproductlistall: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    getsubproductlist: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                console.log(response.data, "data");
                if (response.data.errorCode == "9999") {
                    console.log(response, "res");
                    returnData = response.data;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    insertUpdateWaste: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    deleteaccmaster: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
           
                if (response.data.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    deletedepmaster: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    getTagTypelist: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    getdealersmithlist: async function (apiURL) {
        try {
            let returnData = {};
            await axios({
                method: "get",
                url: config.apiEndPoint + apiURL
            }).then((response) => {
                if (response.data.results.errorCode == "9999") {
                    returnData = response.data.results;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    uploadeimg: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                console.log(response.data, "data");
                if (response.data.errorCode == "9999") {
                    console.log(response, "res");
                    returnData = response.data;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },

    insertUpdateItem: async function (apiURL, postData) {
        try {
            let returnData = {};
            await axios({
                method: "post",
                url: config.apiEndPoint + apiURL,
                data: postData
            }).then((response) => {
                if (response.data?.[0]?.[0].return_val == true) {
                    returnData = response.data?.[0]?.[0].return_msg;
                } else {
                    returnData = "-1";
                }
            });
            return returnData;
        } catch (e) {
            console.log(e);
        }
    },






}
export default apiservice;